import Flickity from "flickity";

export default class BasePostGridSlider {
    isPreview = false;
    autoplay = false;
    infinite = false;
    draggable = false;
    slider = null;
    sliderContainer = null;
    totalWidth = 0;
    slideXTotal = 0;
    sliderEnd = false;
    videoPlaying = true;
    selectedIndex = 0;
    loading = true;
    isLoading = false;   
    currentFilters = {};
    postGridSlider = null;
    filterPrefix = {
        'taxonomy': 'filter-t-',
        'meta' : 'filter-m-',
        'search': '',
    };
    cardActive = false;

    constructor(draggable = false, autoplay = false, direction = 'forward', infinite = false, freeScroll = false) {
        this.draggable = draggable;
        this.autoplay = autoplay;
        this.direction = direction;
        this.infinite = infinite; 
        this.freeScroll = freeScroll;
    }          

    init() {
        this.postGridSlider = this.$el;
        this.currentFilters = this.getCurrentFilters();
        this.filterContainer = this.$refs.filterContainer;
        this.sliderContainer = this.$refs.slider;

        this.isPreview = this.$el.dataset.pegasusIsPreview === '1';

        if (this.sliderContainer) {
            const slides = this.sliderContainer.querySelectorAll(".slide");
            if (slides.length > 0 && !this.isPreview) {
                this.initFlickity(slides);
            }
        } else {
            console.error("Slider container is not defined.");
        }
    }

    // Dispatch toggle-filter event to PostFilterBook
    dispatchFilterEvent(term, filterName, type = 'taxonomy') {
        this.$dispatch('toggle-filter', { term, filterName, type }, { bubbles: true });
        const target = document.querySelector('section[x-data="postFilterBook"]');

        if (target) {
            pegasus.scroll(target, -200, 'scrollTo');
        } else {
            console.warn('Target section not found for scrolling.');
        }
    }

    initFlickity(slides) {
        const isMobileOrTablet = window.innerWidth <= 1366;
    
        let options = {
            cellAlign: "left",
            contain: true,
            wrapAround: this.infinite,
            freeScroll: this.freeScroll,
            prevNextButtons: false,
            pageDots: false,
            draggable: isMobileOrTablet,
            on: {
                settle: () => {
                    this.updateTabIndexes(slides);
                    // this.updateArrowOpacity();
                    this.updateSliderEnd();
                },
                change: () => {
                    this.selectedIndex = this.slider.selectedIndex;
                    // this.updateArrowOpacity();
                },
            },
        };

    
        // Smooth autoplay for freeScroll mode
        if (this.autoplay && typeof this.autoplay === 'number' && this.autoplay > 0) {
            setInterval(() => {
                const scrollSpeed = 1; // Adjust the speed of scrolling
                
                if (this.direction === 'reverse') {
                    this.slider.x += scrollSpeed; // Scroll backward
                } else {
                    this.slider.x -= scrollSpeed; // Scroll forward
                }

                this.slider.settle(this.slider.x); // Update slider position
            }, 16); // Adjust the interval for smooth animation (16ms ~ 60fps)
        }
    
        // Initialize Flickity slider
        this.slider = new Flickity(this.sliderContainer, options);
    
        this.getSlideXTotal(slides);
        this.updateTabIndexes(slides);
        this.updateProgressBar();
    
        pegasus.onResizeFinished(() => {
            this.totalWidth = 0;
            this.getSlideXTotal(slides);
            this.updateProgressBar();
        });
    
        this.slider.on("scroll", () => {
            this.updateProgressBar();
        });
    
        // Initial arrow opacity check
        // this.updateArrowOpacity();
    
        // Define scroll sensitivity threshold for trackpad scrolling
        let scrollThreshold = 300;
        let accumulatedScroll = 0;
    
        const flickitySlider = this.sliderContainer.querySelector('.flickity-slider');
    
        if (flickitySlider) {
            flickitySlider.addEventListener('wheel', (event) => {
                // Get the slider's position relative to the top of the viewport
                const sliderTopPosition = this.sliderContainer.getBoundingClientRect().top;
    
                if (sliderTopPosition > 300) {
                    return;
                }
    
                const atStart = this.slider.selectedIndex === 0;
                const atEnd = this.slider.selectedIndex === this.slider.slides.length - 1;
    
                if ((atStart && event.deltaY < 0) || (atEnd && event.deltaY > 0)) {
                    return;
                }
    
                event.preventDefault();
                accumulatedScroll += event.deltaY;
    
                if (accumulatedScroll >= scrollThreshold) {
                    this.slider.next();
                    accumulatedScroll = 0;
                } else if (accumulatedScroll <= -scrollThreshold) {
                    this.slider.previous();
                    accumulatedScroll = 0;
                }
            });
        }
    }

    disabledArrow(direction = 'next', slidesToShow = 3) {

        if (!this.slider || !this.slider.slides) {
            return true;
        }
        
        const slides = this.slider.slides;
        const slideCount = slides.length;
        const selectedIndex = this.slider.selectedIndex;
        const isAtStart = selectedIndex === 0;
    
        let showCount = 3;
        if (window.innerWidth <= 1199) {
            showCount = 2;
        } else if (window.innerWidth <= 767) {
            showCount = 1;
        }
    
        let isAtEnd = selectedIndex === slideCount - showCount;
        
        if (direction === 'next') {
            return isAtEnd;
        } else {
            return isAtStart;
        }
    }    

    updateArrowOpacity() {
        const prevButton = this.$refs.prevButton;
        const nextButton = this.$refs.nextButton;
    
        if (prevButton && nextButton) { // Check if both buttons exist
            if (!this.infinite) {
                prevButton.style.opacity = this.selectedIndex === 0 ? '0.25' : '1';
                prevButton.style.pointerEvents = this.selectedIndex === 0 ? 'none' : '';
                nextButton.style.opacity = this.selectedIndex === this.slider.slides.length - 1 ? '0.25' : '1';
                nextButton.style.pointerEvents = this.selectedIndex === this.slider.slides.length - 1 ? 'none' : '';
            } else {
                prevButton.style.opacity = '1';
                prevButton.style.pointerEvents = '';
                nextButton.style.opacity = '1';
                nextButton.style.pointerEvents = '';
            }
        }
    }
    

    next() {
        if(this.isPreview) {
            const slider = this.$root.querySelector(".slider");
            const slides = slider.querySelectorAll(".slide");

            // scroll to the next slide
            slider.scrollLeft += slides[0].offsetWidth;
        } else {
            this.slider.next();
        }
    }

    previous() {
        if(this.isPreview) {
            const slider = this.$root.querySelector(".slider");
            const slides = slider.querySelectorAll(".slide");

            // scroll to the next slide
            slider.scrollLeft -= slides[0].offsetWidth;
        } else {
            this.slider.previous();
        }
    }

    destroySlider() {
        if (this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

    getSlideXTotal(slides) {
        slides.forEach((slide) => {
            this.totalWidth += slide.offsetWidth;
        });

        if (this.infinite) {
            this.slideXTotal = (this.totalWidth - this.sliderContainer.offsetWidth) + ((this.sliderContainer.offsetWidth / 2) + (this.totalWidth / slides.length));
        } else {
            this.slideXTotal = this.totalWidth - this.sliderContainer.offsetWidth;
        }
    }
    updateSliderEnd() {
        const selectedIndex = this.slider.selectedIndex;
        const slideCount = this.slider.slides.length;
        this.sliderEnd = selectedIndex === slideCount - 1;
    }
    updateTabIndexes(slides) {
        slides.forEach((slide) => {
            const slideElements = slide.querySelectorAll("a, button");

            slideElements.forEach((element) => {
                if (slide.classList.contains("is-selected")) {
                    element.removeAttribute("tabindex");
                } else {
                    element.setAttribute("tabindex", "-1");
                }
            });
        });
    }

    updateProgressBar() {
        const progressBar = this.$refs.progressBar;
        if (!progressBar) return;
        const progress = (Math.abs(this.slider.x) / this.slideXTotal) * 100;
        progressBar.style.width = progress + "%";
    }

    toggleFilters(term = '', filterName = '', type = 'taxonomy', location = '') {
        const filter = this.getPrefixedFilter(filterName, type);
    
        if (location) {
            this.currentFilters['filter-t-location'] = location;
        }
    
        this.currentFilters[filter] = term;
        this.fetchContent();
    }
    

    removeFilter(filter, value) {
        const filterValue = this.currentFilters[filter];
        const filterValueArray = filterValue.split(',');

        for (let i = 0; i < filterValueArray.length; i++) {
            if (filterValueArray[i] === value) { 
                filterValueArray.splice(i, 1); 
            }   
        }

        return filterValueArray.toString();
    }

    clearFilters() {
        this.currentFilters = {};
        const url = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
        history.pushState({}, '', url);
    
        this.isLoading = true;
    
        this.fetchContent(url);
    }
      
    fetchContent(href = null) {
        const postGridSlider = this.postGridSlider ? this.postGridSlider.querySelector('[data-pegasus-filterable]') : null;
        const elements = postGridSlider ? [`data-pegasus-filterable="${postGridSlider.dataset.pegasusFilterable}"`] : [];
        
        if (href) {
            this.currentUrl = href;
        } else if (!Object.keys(this.currentFilters).length) {
            this.currentUrl = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
        } else {
            this.currentUrl = this.buildUrl();
        }
        
        this.isLoading = true;
        
        pegasus.ajaxContent(this.currentUrl, elements, {}, () => {
            this.isLoading = false;
            history.pushState(JSON.stringify(this.currentFilters), '', this.currentUrl);
    
            if (this.filterContainer instanceof HTMLElement) {
                pegasus.scroll(this.filterContainer, -100, 'scrollTo');
            } else {
                console.error("Filter container is not a valid HTML element:", this.filterContainer);
            }
    
            this.destroySlider();
            this.sliderContainer = this.$refs.slider;
    
            if (this.sliderContainer) {
                const slides = this.sliderContainer.querySelectorAll(".slide");
                this.initFlickity(slides);
                this.getSlideXTotal(slides);
                this.updateProgressBar();
                this.updateSliderEnd();
            }
    
            if (typeof window.modal !== "undefined") {
                window.modal.init();
            }
        });
    }    

    getCurrentFilters() {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        let currentFilters = {};
    
        for (const [key, value] of params.entries()) {
            currentFilters[key] = value;
        }
    
        return currentFilters;
    }    

    filterIsActive(term, filter, type = 'taxonomy') {
        const filterName = this.getPrefixedFilter(filter, type);
        if (typeof this.currentFilters[filterName] !== "undefined") {
            return this.currentFilters[filterName].includes(term);
        }
        return false;
    }

    buildUrl() {
        let url = window.location.protocol + '//' + window.location.hostname + window.location.pathname + '?';
        let i = 1;

        for (const [key, value] of Object.entries(this.currentFilters)) {
            url += `${key}=${value}`;
            if (i < Object.keys(this.currentFilters).length) {
                url += '&';
            }
            i++;
        }

        return url;
    }

    getPrefixedFilter(filter, type = 'taxonomy') {
        return `${this.filterPrefix[type]}${filter}`;
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("postGridSlider", (draggable, autoplay, direction = 'forward', infinite = false, freeScroll = false) => new BasePostGridSlider(draggable, autoplay, direction, infinite, freeScroll));
});

document.addEventListener('alpine:init', () => {
    Alpine.data('singleSliderCard', () => ({
        cardActiveState: false,
        isHovered: false
    }));
});
